export default __webpack_public_path__ + "static/media/image18.a9dcf91a.jpeg";